import { Party, Stored } from "../types";
import { getImageFromS3 } from "../utils";

export default function PartyInfo({ party }: { party: Stored<Party> }) {
  return (
    <details className="party-info">
      <summary className="party-info__summary">
        {party.hasLogo && (
          // We don;t need alt text here, as the party name is just below
          <img
            src={getImageFromS3(`parties/${party._id}`)}
            alt=""
            className="party-info__logo"
          />
        )}
        {party.name}

        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="currentcolor"
          className="party-info__toggle"
        >
          <path d="M12 8.6L6 14.6L7.4 16L12 11.4L16.6 16L18 14.6L12 8.6Z" />
        </svg>
      </summary>
      {party.description}
    </details>
  );
}
